/// <amd-module name="Tfs/ProjectsDropdown/ProjectsService" />
import { TeamProjectReference } from "Tfs/Platform/Contracts/Core";
import { getCoreClient } from "Tfs/Platform/RestClient/Core";
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";
import { IVssService, Services, VssService } from "VSS/Platform/Context";

export interface IProjectsService extends IVssService {
    /**
     * Gets a list of all team projects in this collection/organization
     */
    getAllProjects(): IReadonlyObservableArray<TeamProjectReference>;
}

export class ProjectsService extends VssService implements IProjectsService {
    private allProjects: ObservableArray<TeamProjectReference>;

    public getAllProjects(): IReadonlyObservableArray<TeamProjectReference> {
        if (!this.allProjects) {
            this.allProjects = new ObservableArray<TeamProjectReference>();
            this.fetchProjects(0);
        }
        return this.allProjects;
    }

    private async fetchProjects(skip: number): Promise<void> {
        const client = getCoreClient(this.pageContext);
        const projects = await client.getProjects(undefined, 1000, skip);

        const allProjects = [...this.allProjects.value, ...projects];
        allProjects.sort((p1, p2) => localeIgnoreCaseComparer(p1.name, p2.name));

        this.allProjects.value = allProjects;

        if (projects.length === 1000) {
            this.fetchProjects(skip + 1000);
        }
    }
}

Services.add("IProjectsService", { serviceFactory: ProjectsService });
